import styled from 'styled-components'

export const dialogPanel = `
    w-[565px] 
    h-[382px] 
    transform 
    overflow-hidden 
    rounded-2xl 
    bg-white 
    p-8 
    text-center 
    align-middle 
    shadow-xl 
    transition-all
`

export const dialogTitle = `
    text-xl 
    font-semibold 
    text-center
    mb-6
`

export const ContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1.5rem;
    height: 100%;
`

export const Body = styled.div`
    color: #374151;
    font-size: 16px;
    line-height: 1.5;
    text-align: center;
    max-width: 400px;
`

export const ButtonsContainer = styled.div`
    display: flex;
    gap: 16px;
    justify-content: center;
    align-items: center;
    margin-top: 2rem;
    width: 100%;
`

export const ButtonAction = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 38px;
    padding: 8px 16px;
    border: 1px solid;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.2s ease-in-out;
    cursor: pointer;
    min-width: 140px;
    
    &:focus {
        outline: none;
        box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.5);
    }
    
    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
    
    &:active {
        transform: scale(0.95);
    }
    
    &:hover {
        filter: brightness(0.9);
    }
`
